/**
 * Development environment.
 *
 * Replaces the React app's `import.meta.env.VITE_*` / `.env` setup.
 * `shared/configs/global.ts` re-exports this as `GlobalConfig`, so every
 * existing call site (`GlobalConfig.KEY_TOKEN`, ...) is unchanged.
 */
export const environment = {
  production: false,

  URL_API: 'https://staging-api-superk.superapp.id/travelpath',
  URL_API_CDN: '',

  /**
   * Sent as the `X-Customer-Code` request header.
   * The React app read `GlobalConfig.ACCESS_CODE`, which was never defined —
   * every request shipped `X-Customer-Code: null`. Defined here.
   */
  ACCESS_CODE: '',

  KEY_TOKEN: 'travelpath.token',
  KEY_USER: 'travelpath.user',

  /**
   * Milliseconds. The React app used `15`, which CapacitorHttp interprets as
   * 15ms — every native request timed out. Only unnoticed because the values
   * are ignored on the web.
   */
  CONNECT_TIMEOUT_API: 15000,
  READ_TIMEOUT_API: 15000,

  GOOGLE_OAUTH_CLIENT_ID:
    '1002030817201-205k79sceae51tsfipbgv9uesfegda4n.apps.googleusercontent.com',

  /**
   * Kill switch for uploading recordings.
   *
   * With this off the recorder, poster frame, preview and delete all still
   * work, but saving uploads no recording and the job's file list carries only
   * photos. Kept because a recording is tens of megabytes on a field
   * connection, where the photos alone are the evidence that matters.
   */
  enableVideoUpload: true,

  /**
   * Burns the watermark into the recording itself, by re-encoding it through
   * a canvas. Off leaves capture, preview and upload working with an
   * unwatermarked clip -- the poster frame is watermarked either way, but is
   * never uploaded. Separate from enableVideoUpload so a device family that
   * misbehaves during the burn can be handled without dropping video.
   */
  enableVideoWatermarkBurn: true,

  /**
   * Web push through Firebase Cloud Messaging. Off until FIREBASE_CONFIG and
   * FIREBASE_VAPID_KEY are filled in: with it off the permission banner never
   * shows, no service worker is registered and no token reaches the API. Also
   * the kill switch if push misbehaves on a device family.
   */
  enablePushNotifications: true,

  /** Firebase console -> Project settings -> General -> Your apps (Web). */
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyCNzy12Q9eW_Z8v2VDFZO38deZGTOoyiaA",
    authDomain: "superfoods-dev.firebaseapp.com",
    projectId: "superfoods-dev",
    storageBucket: "superfoods-dev.firebasestorage.app",
    messagingSenderId: "182869966028",
    appId: "1:182869966028:web:8120cbcbd78db5fa64d669",
    measurementId: "G-QGTRKTPFSC"
  },


  /** Firebase console -> Project settings -> Cloud Messaging -> Web Push certificates. */
  FIREBASE_VAPID_KEY: 'BN4gTT_A68UsVsEvvwYNMbbObA6Ti0I0Us9hUZzrRvTAL6YrCvYzHRZ48EfBvI8KWHlNcXf_1duoXU8LoE8AxCU',

  /**
   * Route guards. The React `PrivateRoute` returned the component
   * unconditionally, leaving its guard logic unreachable — every route was
   * public. Set false to restore that behaviour while building UI.
   */
  enableAuthGuard: true,
};

export type AppEnvironment = typeof environment;
